/**
 * The generator's structured "no answer" flag (backend `NO_ANSWER_SENTINEL`). The server never streams it and
 * never stores it in a message (it holds back anything that could still become it); this is the second line of
 * defence. The reducer applies it to the accumulated text, so a marker split over stream pieces is removed as
 * soon as its last piece arrives.
 */
export const NO_ANSWER_MARKER = "[[NO_ANSWER]]";

/** `text` without the marker, wherever it is and however many times. */
export function withoutNoAnswerMarker(text: string): string {
  return text.includes(NO_ANSWER_MARKER) ? text.split(NO_ANSWER_MARKER).join("") : text;
}
